import { styled } from '@mui/system';
import { Chip, Paper, IconButton, Typography, Link, FormGroup, InputBase } from '@mui/material';

export const SubComponentContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  gap: 16
}));

export const DisabledOptionText = styled('p')(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2)
}));

export const Label = styled('div')(() => ({
  width: '20%',
  minWidth: '20%',
  wordWrap: 'break-word'
}));

export const FilterButton = styled(IconButton)(({ theme }) => ({
  height: '100%',
  background: '#FFF',
  borderRadius: 6,
  padding: '10px 32px',
  [theme.breakpoints.down('sm')]: {
    background: '#EEE'
  }
}));

export const FilterButtonLabel = styled('span')(() => ({
  color: '#000000de',
  fontSize: 18,
  paddingLeft: 6
}));

export const BadgeContainer = styled('div')(() => ({
  width: 39,
  height: 39,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%'
}));

export const BadgeContainerActive = styled(BadgeContainer)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main
  }
}));

export const BadgeIcon = styled('span')(() => ({
  color: '#000000de',
  display: 'flex'
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  margin: '4px 3px',
  padding: '12px 0',
  borderRadius: 6,
  lineHeight: 32,
  height: 32,
  minHeight: 32,
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
    maxHeight: 32,
    '& svg': {
      fontSize: '1.5rem',
      cursor: 'pointer',
      color: '#878787',
      marginLeft: theme.spacing(1)
    }
  },
  '& .MuiChip-deleteIcon': {
    fontSize: 22
  }
}));

export const DeviceChip = styled(StyledChip)(() => ({
  border: 0,
  boxShadow: 'none !important',
  lineHeight: 32,
  height: 32,
  minHeight: 32,
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
    maxHeight: 32,
    paddingRight: 0,
    gap: 4,
    '& svg': {
      fontSize: '1.5rem',
      cursor: 'pointer',
      color: '#878787'
    }
  },
  '& .MuiChip-deleteIcon': {
    fontSize: 22
  },
  '&:hover': {
    backgroundColor: 'transparent !important'
  }
}));

export const DeviceChipContainer = styled('div')(() => ({
  margin: '4px 3px',
  borderRadius: 6,
  border: '1px solid #bdbdbd'
}));

export const DateRangeWrapper = styled('div')(({ theme }) => ({
  gridArea: 'dateRange',
  '& section': {
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  '& input': {
    padding: '18px 0px 18px 14px'
  },
  '& .Mui-selected': {
    padding: '18px 0px 18px 14px'
  },
  '& .MuiInputAdornment-positionEnd': {
    margin: 0
  },
  '& p.Mui-error': {
    position: 'absolute',
    margin: 0,
    padding: '0 14px',
    top: 60,
    background: '#fff',
    width: '100%',
    zIndex: 10,
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
  }
}));

export const SearchPaper = styled(Paper)(({ theme }) => ({
  padding: '2px 4px',
  display: 'flex',
  alignItems: 'center',
  width: '75%',
  boxShadow: 'none',
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));

export const SearchIcon = styled('span')(() => ({
  margin: 10,
  color: '#0000008a',
  display: 'flex'
}));

export const SearchErrorText = styled('span')(() => ({
  position: 'absolute',
  left: 0,
  bottom: -26,
  fontSize: 12,
  color: '#f44336'
}));

export const SearchInput = styled(InputBase)({
  marginLeft: 8,
  flex: 1
});

export const ClearSearchButton = styled(IconButton)({
  marginRight: 8
});

export const CheckboxesGroup = styled(FormGroup)(({ theme }) => ({
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));

export const FilterHeader = styled(Typography)(() => ({
  padding: '20px 0'
}));

export const OpenLink = styled(Link)(() => ({
  height: 34,
  width: 34,
  position: 'relative'
}));

export const CloseBtn = styled(IconButton)(() => ({
  position: 'absolute',
  left: 0,
  top: 0
}));

export const FilterOpenButton = styled(IconButton)(() => ({
  padding: 10
}));

export const FilterOpenButtonActive = styled(FilterOpenButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main
  }
}));
